import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const SearchPanelStatusChanged = createAction(
  '[Data Customization: Tag Management Search]: Panel Status Changed',
);

export const SearchTagTypeChanged = createAction(
  '[Data Customization: Tag Management Search]: Tag Type Changed',
  props<{ tagType: string }>(),
);

export const SearchTagCodeChanged = createAction(
  '[Data Customization: Tag Management Search]: Tag Code Changed',
  props<{ tagCode: string }>(),
);

export const SearchTagLabelChanged = createAction(
  '[Data Customization: Tag Management Search]: Tag Label Changed',
  props<{ tagLabel: string }>(),
);

export const GetTags = createAction('[Data Customization: Tag Management Search]: Get Tags');

export const GetTagsSuccess = createAction(
  '[Data Customization: Tag Management Search]: Get Tags Success',
  props<{ res: any }>(),
);

export const GetTagsFailed = createAction(
  '[Data Customization: Tag Management Search]: Get Tags Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ClearSearchTagOptions = createAction(
  '[Data Customization: Tag Management Search]: Clear Search Tag Options',
);
